<mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="page.length" [pageSize]="page.pageSize"
  [pageIndex]="page.pageIndex" (page)="pageChange($event)" aria-label="Select page">
</mat-paginator>
